
import { get, post } from 'helpers/api';

const rootPath = '/integrations/quickbooks/account';

export async function search({ type, ...fields }, callback) {
  const results = await get(`${rootPath}/search`, { params: { type, ...fields } });
  callback(results);
}

export async function loadObject({ type, id }, callback) {
  const result = await get(`${rootPath}/object/${type}/${id}`);
  callback(result);
}

export async function createObject({ type, ...fields }, onSuccess, onError) {
  try {
    const result = await post(`${rootPath}/object/${type}`, fields);
    onSuccess(result);
  } catch (error) {
    onError?.(fields, error);
  }
}

export function buildCustomerBody(contact) {
  return {
    contactType: contact.contactType,
    ...(contact.contactType === 'business'
      ? { name: contact.name }
      : { givenName: contact.firstName, familyName: contact.lastName }),
    ...(contact.email && { email: contact.email }),
    ...(contact.phoneNumber && { phone: contact.phoneNumber }),
  };
}

export function buildVendorBody(buildoutObject) {
  if (buildoutObject.contactType) {
    return buildVendorBodyFromContact(buildoutObject);
  } else {
    return buildVendorBodyFromBroker(buildoutObject);
  }
}


function buildVendorBodyFromContact(contact) {
  console.log(`Building from contact: ${JSON.stringify(contact)}`);
  return {
    displayName: contact.name,
    ...(contact.email && { email: contact.email }),
    ...(contact.phoneNumber && { phone: contact.phoneNumber }),
  };
}

function buildVendorBodyFromBroker(broker) {
  return {
    displayName: broker.name,
    ...(broker.email && { email: broker.email }),
    ...(broker.phoneFormatted && { phone: broker.phoneFormatted }),
    ...(broker.addressFormatted && { address: broker.addressFormatted }),
  };
}

const BODY_BUILDERS = { customer: buildCustomerBody, vendor: buildVendorBody };

export function buildCreateBody(type, data) {
  return BODY_BUILDERS[type](data);
}
